import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCapacitorComponent } from './simple-icons-capacitor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCapacitorComponent ],
    exports:      [ SimpleIconsCapacitorComponent ],
    bootstrap:    []
})
export class SimpleIconsCapacitorModule {}
